angular
    .module('app')
    .filter(
        'myCurrency',
        [
            '$filter', function() {
                return function(input) {
                    input = parseFloat(input);
                    input = input.toFixed(input % 1 === 0 ? 0 : 2);
                    return '$' + input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                };
            }
        ]);